import { render, staticRenderFns } from "./VolOrgLogin.vue?vue&type=template&id=4401248a"
import script from "./VolOrgLogin.vue?vue&type=script&lang=js"
export * from "./VolOrgLogin.vue?vue&type=script&lang=js"
import style0 from "./VolOrgLogin.vue?vue&type=style&index=0&id=4401248a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports